import React, { useState } from 'react';
import { SERVER } from '../config/config';

const ServerImage = ({ 
  src, 
  alt, 
  fallback = '/studio/photo1.png', 
  className = '', 
  onLoad, 
  onError,
  debug = false,
  style,
  ...htmlProps 
}) => {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Filter out non-HTML attributes
  const validHtmlProps = {};
  const validAttributes = [
    'id', 'className', 'style', 'onClick', 'onMouseOver', 'onMouseOut',
    'onLoad', 'onError', 'loading', 'decoding', 'crossOrigin', 'sizes',
    'srcSet', 'useMap', 'width', 'height', 'draggable'
  ];

  Object.keys(htmlProps).forEach(key => {
    if (validAttributes.includes(key) || key.startsWith('data-') || key.startsWith('aria-')) {
      validHtmlProps[key] = htmlProps[key];
    }
  });

  // Construct proper image URL
  const getImageUrl = (url) => {
    if (!url) return fallback;
    
    if (url.startsWith('http')) {
      // Full URL - use as-is
      return url;
    } else if (url.startsWith('/')) {
      // Server relative URL - combine with SERVER
      return `${SERVER}${url}`;
    } else {
      // Relative URL without leading slash - add slash and combine
      return `${SERVER}/${url}`;
    }
  };

  const imageUrl = hasError ? fallback : getImageUrl(src);

  const handleLoad = (e) => {
    setIsLoading(false);
    if (debug) {
      console.log('ServerImage loaded successfully:', imageUrl);
    }
    if (onLoad) onLoad(e);
  };

  const handleError = (e) => {
    setIsLoading(false);
    setHasError(true);
    if (debug) {
      console.log('ServerImage failed to load:', imageUrl, 'falling back to:', fallback);
    }
    if (onError) onError(e);
  };

  return (
    <div className="relative">
      <img
        src={imageUrl}
        alt={alt}
        className={`${className} rounded-none`}
        style={{ borderRadius: '0px', ...style }}
        onLoad={handleLoad}
        onError={handleError}
        {...validHtmlProps}
      />
      
      {/* Loading indicator */}
      {isLoading && (
        <div className="absolute inset-0 bg-gray-100 animate-pulse flex items-center justify-center">
          <div className="w-8 h-8 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
        </div>
      )}
    </div>
  );
};

export default ServerImage;